module.exports = __webpack_public_path__ + "img/money.75265094.svg";